import logo from './logo.svg';
import './App.css';
import Home from './components/home'


import ChatForm from './components/chatForm';
import { Route, Routes } from 'react-router-dom';
import BookingForm from './components/bookingForm';
import Venue from './components/venue';
import PlanYourTrip from './components/Planyourtrip';
import  DocumentViewer from './components/report'
import Programme from './components/programme';
import Contact from './components/contact';
import ComingSoon from './components/comingSoon';
//import NorthernCapeTourism from './components/northerncapeTourism';

import About from './components/about';
function App() {
  return (
     <Routes> 
      <Route path='/' element={<Home/>} />
      <Route path='/chatForm' element={<ChatForm/>} />
      <Route path='/bookForm' element={<BookingForm/>} />
      <Route path='/venue' element={<Venue/>} />
      <Route path='/plantrip' element={<PlanYourTrip/>} />
      <Route path='/about' element={<About/>} />
      <Route  path="/report"  element={<DocumentViewer/>}/>
      
      <Route path="/contact"  element={<Contact/>} />
      <Route path="/programme" element={<ComingSoon />} />
<Route path="/speakers" element={<ComingSoon />} />
<Route path="/xp" element={<ComingSoon />} />
    </ Routes>
  );
}

export default App;
